import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import NavbarLandingsPage from "../components/NavbarLandingsPage.jsx";
import axiosInstance from "../api/axiosConfig.jsx";


const BookDemoPage = () => {
    const [formData, setFormData] = useState({
        contactPerson: '',
        company: '',
        email: '',
        phoneNumber: '',
        privacyAgreed: false
    });

    const [successMessage, setSuccessMessage] = useState('');
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateForm = () => {
        let errors = {};

        if (!formData.contactPerson.trim()) {
            errors.contactPerson = 'Contactpersoon is verplicht';
        }
        if (!formData.company.trim()) {
            errors.company = 'Bedrijfsnaam is verplicht';
        }
        if (!formData.email.trim()) {
            errors.email = 'Email is verplicht';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Ongeldig emailadres';
        }
        if (!formData.phoneNumber.trim()) {
            errors.phoneNumber = 'Telefoonnummer is verplicht';
        }
        if (!formData.privacyAgreed) {
            errors.privacyAgreed = 'U moet akkoord gaan met het privacybeleid';
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            const response = await axiosInstance.post('/subscribers', formData);

            if (response.status === 200) {
                setSuccessMessage('Bedankt voor uw interesse in HorecaMasters, we nemen spoedig contact met u op voor een demo.');
                setFormData({ contactPerson: '', company: '', email: '', phoneNumber: '', privacyAgreed: false });
                setErrors({});
            } else {
                setSuccessMessage('Er is iets misgegaan, probeer het later opnieuw.');
            }
        } catch (error) {
            console.error('Error:', error);
            setSuccessMessage('Er is een fout opgetreden, probeer het later opnieuw.');
        }
    };

    return (
        <div style={{backgroundColor: '#131517'}} className="glossy-background  vw-100">
            <NavbarLandingsPage/>
            <div style={{height: '60px'}}></div>

            <Container className="py-5">
                <h1 className="display-4 fw-bold text-center mb-5" style={{color: '#fff'}}>
                    Boek een demo bij HorecaMasters!
                </h1>

                <Row className="align-items-start g-5">
                    {/* Left side content */}
                    <Col md={5} className="pe-md-5">
                        <div className="mb-5 position-relative">
                            <h2 className="h2 mb-4 fw-bold" style={{color: '#fff'}}>
                                Waarom een demo plannen?
                            </h2>
                            <p className="lead" style={{color: '#fff'}}>
                                Met HorecaMasters ontdekt u hoe u kunt besparen op personeelskosten en meer inzicht
                                krijgt in uw bedrijfsvoering.
                                Ontdek tijdens de demo de mogelijkheden die onze software biedt.
                            </p>
                        </div>

                        <div className="position-relative">
                            <h2 className="h2 mb-4 fw-bold" style={{color: '#fff'}} >
                                Wat kunt u verwachten tijdens de demo?
                            </h2>
                            <ul className="list-unstyled" >
                                <li className="mb-4 d-flex align-items-center">
                                    <span className="me-3 fs-5 fw-bold" style={{color: '#008000'}}>✓</span>
                                    <span className="lead" style={{color: '#fff'}}>Persoonlijke uitleg over onze software</span>
                                </li>
                                <li className="mb-4 d-flex align-items-center">
                                    <span className="me-3 fs-5 fw-bold" style={{color: '#008000'}}>✓</span>
                                    <span className="lead" style={{color: '#fff'}}>Mogelijkheid om vragen te stellen</span>
                                </li>
                                <li className="mb-4 d-flex align-items-center">
                                    <span className="me-3 fs-5 fw-bold" style={{color: '#008000'}}>✓</span>
                                    <span className="lead" style={{color: '#fff'}}>Na onze demo ontvang je van ons direct de offerte.</span>
                                </li>
                                <li className="mb-4 d-flex align-items-center">
                                    <span className="me-3 fs-5 fw-bold" style={{color: '#008000'}}>✓</span>
                                    <span className="lead" style={{color: '#fff'}}>Offerte akkoord? Dan implementeren we nog dezelfde week onze software.</span>
                                </li>
                            </ul>
                        </div>
                    </Col>

                    {/* Right side form */}
                    <Col  md={7}>
                        <div style={{backgroundColor:'#f4f5f7'}} className="bg-white text-dark p-5 rounded-4 shadow-lg">
                            <h2 className="h2 mb-4 fw-bold" style={{color: 'black'}}>
                                Boek een demo
                            </h2>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-4">
                                    <Form.Control
                                        type="text"
                                        placeholder="Bedrijfsnaam"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleChange}
                                        required
                                        className="py-3 border-0 bg-light"
                                        isInvalid={!!errors.company}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.company}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-4">
                                    <Form.Control
                                        type="text"
                                        placeholder="Contactpersoon"
                                        name="contactPerson"
                                        value={formData.contactPerson}
                                        onChange={handleChange}
                                        required
                                        className="py-3 border-0 bg-light"
                                        isInvalid={!!errors.contactPerson}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.contactPerson}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-4">
                                    <Form.Control
                                        type="email"
                                        placeholder="Email adres"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        className="py-3 border-0 bg-light"
                                        isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.email}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="mb-4">
                                    <Form.Control
                                        type="tel"
                                        placeholder="Telefoonnummer"
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        required
                                        className="py-3 border-0 bg-light"
                                        isInvalid={!!errors.phoneNumber}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.phoneNumber}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Check
                                        type="checkbox"
                                        label="Ik ga akkoord met het privacybeleid"
                                        name="privacyAgreed"
                                        checked={formData.privacyAgreed}
                                        onChange={handleChange}
                                        isInvalid={!!errors.privacyAgreed}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.privacyAgreed}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Button
                                    variant="primary"
                                    type="submit"
                                    className="w-100 btn btn-accent btn-lg button-landingspage"
                                    style={{
                                        fontSize: '1.1rem'
                                    }}
                                >
                                    Boek een demo
                                </Button>
                            </Form>

                            {successMessage && (
                                <div className="mt-3 alert alert-success">
                                    {successMessage}
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>

            <footer style={{backgroundColor:"#131517"}} className="text-white py-3">
                <div className="container">
                    <div className="row gy-3">
                        {/* Company kolom */}
                        <div className="col-12 col-md-4 text-center text-md-start">
                            <h3 className="h6 mb-2">HorecaMasters</h3>
                            <p className="text-secondary mb-0 medium">
                                &copy; 2024 HorecaMasters.<br/>
                                Alle rechten voorbehouden.
                            </p>
                        </div>

                        {/* Social Media kolom */}
                        <div className="col-12 col-md-4 text-center">
                            <h3 className="h6 mb-2">Volg ons</h3>
                            <div className="d-flex justify-content-center gap-3">
                                <a
                                    href="https://www.facebook.com/profile.php?id=61568664692090"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none d-inline-flex align-items-center gap-2"
                                >
                                    <i className="bi bi-facebook"></i>
                                </a>
                                <a
                                    href="https://www.instagram.com/horeca_masters"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none d-inline-flex align-items-center gap-2"
                                >
                                    <i className="bi bi-instagram"></i>
                                </a>
                                <a
                                    href="https://www.reddit.com/user/HorecaMasters/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none d-inline-flex align-items-center gap-2"
                                >
                                    <i className="bi bi-reddit"></i>
                                </a>
                                <a
                                    href="https://wa.me/31648377546" // Vervang dit door je eigen WhatsApp-nummer
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-white text-decoration-none d-inline-flex align-items-center gap-2"
                                >
                                    <i className="bi bi-whatsapp"></i>
                                </a>
                            </div>
                        </div>

                        {/* Contact kolom */}
                        <div className="col-12 col-md-4 text-center text-md-end">
                            <h3 className="h6 mb-2">Contact</h3>
                            <div className="d-flex flex-column gap-1 align-items-center align-items-md-end">
                                <a
                                    href="mailto:info@horeca-masters.nl"
                                    className="text-white text-decoration-none d-inline-flex align-items-center gap-2 small"
                                >
                                    <i className="bi bi-envelope small"></i>
                                    info@horeca-masters.nl
                                </a>
                                <a
                                    href="tel:+31648377546"
                                    className="text-white text-decoration-none d-inline-flex align-items-center gap-2 small"
                                >
                                    <i className="bi bi-telephone small"></i>
                                    06 4837 7546
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </div>
    );
};

export default BookDemoPage;
